export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para la variable data.
 */
export function resetData(state) {
    state.data = [];
}
export function setFile(state,file) {
    state.params.file = file;
    state.params.validated = false;
}

export function clearParamsBranchofficesWarehouseId(state){
    state.params.branchoffice_warehouse_id = null
}
export function setBranchofficesWarehouses(state, branchoffices_warehouses){
    state.params.branchoffice_warehouse_id = null ;
    state.branchoffices_warehouses = branchoffices_warehouses
}
export function setValidationdata(state, result){
    state.params.validated = result.success

}
export function reset_state(state){
        state.branchoffices= [],
        state.branchoffice_id= null,
        state.warehouse_id= null,
        state.params= {
             branchoffice_id:null,
             branchoffice_warehouse_id: null,
             file: null,
             validated: false,
    }

}



// WEBPACK FOOTER //
// ./src/modules/incorporate_inventory_initial_balance/mutations.js